<template>
    <section class=" h-screen max-w-4xl mx-auto mt-40 px-6 py-16">
        <h1 class="text-5xl font-bold text-primary mb-4">
            Une question, un commentaire ou un problème ?
        </h1>
        <p class="text-lg text-gray-700 mb-8">
            Notre équipe est là pour vous aider. Remplissez le formulaire ci-dessous et nous vous répondrons rapidement.
        </p>

        <form @submit.prevent="sendForm" class="space-y-6">
            <div>
                <label class="block text-gray-700 font-medium mb-1">Nom</label>
                <input type="text" v-model="name"
                    class="w-full border border-gray-300 rounded p-3 focus:outline-none focus:ring-2 focus:ring-primary"
                    required />
            </div>
            <div>
                <label class="block text-gray-700 font-medium mb-1">Email</label>
                <input type="email" v-model="email"
                    class="w-full border border-gray-300 rounded p-3 focus:outline-none focus:ring-2 focus:ring-primary"
                    required />
            </div>
            <div>
                <label class="block text-gray-700 font-medium mb-1">Message</label>
                <textarea rows="5" v-model="message"
                    class="w-full border border-gray-300 rounded p-3 focus:outline-none focus:ring-2 focus:ring-primary"
                    required></textarea>
            </div>
            <button type="submit"
                class="bg-primary text-white rounded px-6 py-2 transition-colors duration-100 hover:bg-primary-dark hover:text-white text-lg font-medium">
                Envoyer
            </button>
            <p class="text-xs text-gray-600 mt-2">
                En soumettant ce formulaire, vous acceptez que vos données soient utilisées uniquement pour vous
                recontacter dans le cadre de votre demande. Aucune donnée n’est vendue ni transmise à des tiers.
                <RouterLink to="/privacy-policy" class="underline">En savoir plus</RouterLink>.
            </p>

        </form>
        <!-- Modal succès -->
        <div v-if="showSuccess" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div class="bg-white rounded p-8 max-w-sm w-full text-center shadow-lg" role="alert" aria-live="assertive">
                <h2 class="text-2xl font-bold mb-4 text-primary">Message envoyé !</h2>
                <p class="mb-6 text-gray-700">
                    Merci pour votre message, nous vous répondrons très rapidement.
                </p>
                <button @click="showSuccess = false"
                    class="bg-primary text-white px-4 py-2 rounded hover:bg-hover transition duration-200">
                    Fermer
                </button>
            </div>
        </div>
    </section>
</template>

<script setup>
import { ref } from "vue";

const name = ref("");
const email = ref("");
const message = ref("");
const showSuccess = ref(false);

const baseUrl = process.env.VUE_APP_BASE_URL


const sendForm = async () => {
    try {
        const payload = {
            name: name.value,
            email: email.value,
            message: message.value,
        };

        const res = await fetch(`${baseUrl}/api/contact`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload),
        });

        const text = await res.text();

        let data;
        try {
            data = JSON.parse(text);
        } catch (e) {
            return;
        }

        if (res.ok && data.success) {
            showSuccess.value = true; // Affiche la card succès
            // Vide le formulaire
            name.value = "";
            email.value = "";
            message.value = "";
        } else {
            alert("Erreur lors de l’envoi : " + (data.error || "Erreur inconnue"));
        }
    } catch (error) {
        alert("Erreur de connexion.");
    }
};
</script>